<template>

    <v-layout column fill-height align-center justify-start class="white">

        <ldap
          v-if="getActiveTree && getActiveTree.id == 'ldap'"
        />
        <keycloak
          v-if="getActiveTree && getActiveTree.id == 'keycloak'"
        />
        <vinteo
          v-if="getActiveTree && getActiveTree.id == 'vinteo'"
        />
        <smtp
          v-if="getActiveTree && getActiveTree.id == 'email'"
        />
        <sms
          v-if="getActiveTree && getActiveTree.id == 'sms'"
        />
        <push
          v-if="getActiveTree && getActiveTree.id == 'push'"
        />
        <ztp
          v-if="getActiveTree && getActiveTree.id == 'ztp_configuration'"
        />
        <templates
          v-if="getActiveTree && getActiveTree.id == 'templates'"
        />
        <panels
          v-if="getActiveTree && getActiveTree.id == 'panels'"
        />
        <tables
          v-if="getActiveTree && getActiveTree.id == 'tables'"
        />
        <ztp-templates
          v-if="getActiveTree && getActiveTree.id == 'ztp_templates'"
        />
        <logged-users
          v-if="getActiveTree && getActiveTree.id == 'current_sessions'"
        />
        <session-settings
          v-if="getActiveTree && getActiveTree.id == 'session_settings'"
        />
        <service-status
          v-if="getActiveTree && getActiveTree.id == 'service_status'"
        />
        <users
          v-if="getActiveTree && getActiveTree.id == 'users'"
        />
        <license
          v-if="getActiveTree && getActiveTree.id == 'license'"
        />
        <backup-panel
          v-if="getActiveTree && getActiveTree.id == 'backup_management'"
        />
        <self-diagnosis
          v-if="getActiveTree && getActiveTree.id == 'self_diagnosis'"
        />
        <sertificates
          v-if="getActiveTree && getActiveTree.id == 'sertificates'"
        />
        <books
          v-if="getActiveTree && getActiveTree.id.slice(-5) == '_book'"
        />
        
    </v-layout>

</template>

<script lang="ts">
import Vue from 'vue'
import smtp from '@/nms/pages/configuration/components/notifications-smtp.vue'
import push from '@/nms/pages/configuration/components/notifications-push.vue'
import sms from '@/nms/pages/configuration/components/notifications-sms.vue'
import ldap from '@/nms/pages/configuration/components/ldap.vue'
import keycloak from '@/nms/pages/configuration/components/keycloak.vue'
import vinteo from '@/nms/pages/configuration/components/vinteo.vue'
import dhcp from '@/nms/pages/configuration/components/dhcp.vue'
import ztp from '@/nms/pages/configuration/components/ztp.vue'
import ztpTemplates from '@/nms/pages/configuration/components/ztp-templates.vue'
import templates from '@/nms/pages/configuration/components/templates.vue'
import panels from '@/nms/pages/configuration/components/panels.vue'
import tables from '@/nms/pages/configuration/components/tables.vue'
import loggedUsers from '@/nms/pages/configuration/components/logged-users.vue'
import sessionSettings from '@/nms/pages/configuration/components/session-settings.vue'
import users from '@/nms/pages/configuration/components/users.vue'
import books from '@/nms/pages/configuration/components/books.vue'
import serviceStatus from '@/nms/pages/configuration/components/service-status.vue'
import license from '@/nms/pages/configuration/components/license.vue'
import backupPanel from '@/nms/pages/configuration/components/backup-panel.vue'
import sertificates from '@/nms/pages/configuration/components/sertificates.vue'
import selfDiagnosis from '@/nms/pages/configuration/components/self-diagnosis.vue'

// Типы
interface StructureState {
  settings: {
    treeActive: Array<{ id?: string; [key: string]: any }>
  }
}

interface RootState {
  structure: StructureState
}

export default Vue.extend({
  name: 'CONFIGURATION',

  components: {
    dhcp,
    ztp,
    ztpTemplates,
    templates,
    panels,
    tables,
    smtp,
    push,
    sms,
    ldap,
    keycloak,
    vinteo,
    loggedUsers,
    sessionSettings,
    users,
    books,
    serviceStatus,
    license,
    backupPanel,
    sertificates,
    selfDiagnosis
  },

  data(): {
    message: string
  } {
    return {
      message: 'CONFIGURATION'
    }
  },

  computed: {
    getActiveTree(): { id?: string; [key: string]: any } | undefined {
      const state = this.$store.state as unknown as RootState
      let activeTree = state.structure.settings.treeActive?.[0]
      // let sl = activeTree.id.slice(-5)
      // console.log('sl', sl)
      // if(activeTree?.id?.slice(-5) == '_book') {
      //   activeTree.id = 'books'
      // }
      // console.log('activeTree', activeTree)
      return activeTree
    },
  },

  created(): void {
    // Метод предназначен для переопределения при необходимости
  },

  mounted(): void {
    // Метод предназначен для переопределения при необходимости
  },
})
</script>

<style>

</style>
